import "./App.css";
import Waves from "./Waves";
import Projects from "./projects/Projects";

function App() {
  return (
    <div className="">
      <nav className="navbar navbar-custom navbar-fixed-top myNavbar">
        <div className="container">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle"
              data-toggle="collapse"
              data-target=".navbar-main-collapse"
            >
              {" "}
              <i className="fa fa-bars"></i>{" "}
            </button>
            <a className="navbar-brand page-scroll" href="#">
              {" "}
              SHOAIB<span>.</span>{" "}
            </a>
          </div>
          <div className="collapse navbar-collapse navbar-right navbar-main-collapse">
            <ul className="nav navbar-nav">
              <li className="active">
                <a className="smooth-menu" href="#home">
                  Home
                </a>
              </li>
              <li>
                <a className="smooth-menu" href="#about">
                  About
                </a>
              </li>
              <li>
                <a className="smooth-menu" href="#services">
                  Services
                </a>
              </li>
              <li>
                <a className="smooth-menu" href="#portfolio">
                  Portfolio
                </a>
              </li>
              <li>
                <a className="smooth-menu" href="#testimonial">
                  Testimonial
                </a>
              </li>
              <li>
                <a className="smooth-menu" href="#contact">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* <Threeapp /> */}
      <div style={{ position: "relative" }}>
        <Waves />
        <div id="home" className="banner-area section-padding">
          {/* <div className="bg-overlay black"></div> */}
          <div className="containter">
            <div className="row m-0">
              <div className="col-md-12 wel-text">
                <div className="welcome-text">
                  <div
                    className="name-area wow fadeInDown"
                    data-wow-delay="0.2s"
                  >
                    Hello, my name is Shoaib
                  </div>
                  <h1 className="wow fadeInDown" data-wow-delay="0.4s">
                    Ready To Give{" "}
                  </h1>
                  <h1>Creative & Dynamic Solutions To You</h1>
                  <a
                    href="#about"
                    className="my-btn-1 wow fadeInDown"
                    data-wow-delay="0.6s"
                  >
                    Learn more
                  </a>
                  <a
                    href="#contact"
                    className="my-btn-2 wow fadeInDown"
                    data-wow-delay="0.8s"
                  >
                    Get in touch
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="about" className="about-area section-padding">
        <div className="container">
          <div className="row m-0">
            <div
              className="col-md-7 col-sn-8 col-xs-12 wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <div className="about-left">
                <h2 className="section-title">Little About Me</h2>
                <div className="line"></div>
                <h4>
                  I am a Full Stack(MERN) and BlockChain Developer over 4 years
                  of Experience, love to create beautifully designed website and
                  making their Back-end working. MERN Stack ❯ ReactJs ❯ NextJs ❯
                  Typescript ❯ React Native ❯ Dockers ❯ Blockchain ❯ AWS
                </h4>
                <p>
                  Muhammad Shoaib is a certified MERN Stack and Blockchain
                  Developer from Blockchain Expert Solutions,​ Worked as a
                  Senior developer at Apperative Solutions ( UK Based IT
                  consulting company giving services in App development,
                  Blockchain, and Cybersecurity), Team Lead at Infinikorn
                  Company, Managed the CI/CD at Gitlab using AWS hosting
                  services, Selected as a volunteer to UN at the Youth
                  International Conclave Model United Nations (YICMUN).
                </p>
                <a
                  href="images/about/cv.pdf"
                  download
                  style={{ width: "180px" }}
                >
                  Download CV&nbsp;<i className="fa fa-download"></i>
                </a>
              </div>
            </div>
            <div
              className="col-md-5 visible-md visible-lg wow fadeInDown"
              data-wow-delay="0.6s"
            >
              <div className="profile">
                {" "}
                <img
                  src="images/about/about-img.png"
                  alt="profile img"
                  className="img-responsive"
                />{" "}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="services" className="section-padding">
        <div className="container">
          <div className="row m-0">
            <div className="col-md-12">
              <div className="section-header text-center">
                <h2>Services I offer</h2>
              </div>
            </div>
          </div>

          <div className="row m-0">
            <div className="col-md-4 col-sm-4">
              <div
                className="single-service wow fadeInDown"
                data-wow-delay="0.2s"
              >
                <i className="icon icon-laptop"></i>
                <h2>MERN Development</h2>
                <p>
                  3+ year experience in MERN Stack Development. Worked the
                  largest cosmetics brands in Lahore (Pakistan). Complete
                  website from scratch. Pkgs mostly used: ✔Express, ✔Http,
                  ✔Socket.io, ✔EJS, ✔React, ✔Redux, ✔Saga ✔Webpack, ✔MongoDb,
                  ✔Mysql, ✔Prop-types, ✔Moment, ✔Loadash, ✔Body-Parser,
                  ✔Webpack, ✔Restify
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-4">
              <div
                className="single-service wow fadeInDown"
                data-wow-delay="0.4s"
              >
                <i className="icon icon-laptop"></i>
                <h2>ReactJs Frontend Dev.</h2>
                <p>
                  4 Years of experience in Eye-Catching Front end Development
                  using Reactjs with API integration. JavaScript (ES5/ES6) ✔
                  Reactjs, Redux , Context API ✔ Libraries & Middleware (
                  rėdux-thunk,redux-saga ,react-router-dom, Axios etc ) ✔ HTML5,
                  CSS, animation ✔ UI/UX, Responsive ✔ Material UI, ✔ AntD, ✔
                  Reactstrap, ✔ Socket.io, ✔ Bootstrap, ✔ Git.
                </p>
              </div>
            </div>
            <div className="col-md-4 col-sm-4">
              <div
                className="single-service wow fadeInDown"
                data-wow-delay="0.6s"
              >
                <i className="icon icon-laptop"></i>
                <h2>BlockChain Development</h2>
                <p>
                  Developing Blockchain applications in Hyperledger Fabric and
                  Ethereum from scratch. I always tried to build such a thing
                  that is reliable and flexible to use for my client and end
                  customers. EXPERTISE: ✔ Hyperledger Fabric ✔ Hyperledger
                  Composer ✔ Node Js ✔ Web3 ✔ Ethereum ✔ Truffle ✔ Ganache ✔ Git
                  ✔ Gitlab
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Projects />
      <div id="services" className="">
        <div className="row m-3" style={{ padding: "60px 0px" }}>
          <div className="col-md-12">
            <div className="section-header text-center">
              <h2>Live Demos</h2>
            </div>
          </div>
        </div>
        <section id="cta" className="cta cta2">
          <div className="container" data-aos="zoom-in">
            <div className="text-center">
              <h3>GetButler Project</h3>
              <p>
                BUTLER is a bespoke asset, property, and lifestyle management
                company in Singapore that strives to free up time for working
                professionals, by elevating the lifestyle of clients through
                convenience.
              </p>
              <a
                className="cta-btn"
                target="_blank"
                href="https://www.getbutler.com/"
              >
                Demo
              </a>
            </div>
          </div>
        </section>
      </div>

      <div id="services" className="">
        <div className="row m-0">
          <div className="col-md-12">
            <div className="section-header text-center"></div>
          </div>
        </div>
        <section id="cta" className="cta">
          <div className="container" data-aos="zoom-in">
            <div className="text-center">
              <h3>You Like Cars</h3>
              <p>
                You Like Cars is a automobile project of Apperative Solutions,
                UK based software company giving services in App development,
                Blockchain, and Cybersecurity.{" "}
              </p>
              <a className="cta-btn" target="_blank" href="http://ylcdev.tk/">
                Demo
              </a>
            </div>
          </div>
        </section>
      </div>

      <div className="portfolio-area section-padding">
        <div className="container-fluid">
          <div className="row m-0">
            <div className="col-md-12">
              <div className="section-header">
                <h1 style={{ marginBottom: "20px" }} id="rp-heading">
                  Recent Projects
                </h1>
                <h2>React Projects</h2>
              </div>
            </div>
          </div>

          <div className="row m-0 justify-content-center">
            <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
              <div className="gallery-items">
                <a
                  className="view img"
                  href="images/portfolio/4.png"
                  target="_blank"
                >
                  <img
                    src="images/portfolio/small/4.png"
                    alt="portfolio image"
                  />
                </a>

                <div className="gallery-text">
                  <h2>React Formik Project</h2>
                  <p>
                    Form Built in React Using Formik library and react-strap
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
              <div className="gallery-items">
                <a
                  className="view img"
                  href="images/portfolio/5.png"
                  target="_blank"
                >
                  <img
                    src="images/portfolio/small/5.png"
                    alt="portfolio image"
                  />
                </a>

                <div className="gallery-text">
                  <a
                    className=""
                    target="_blank"
                    href="https://react-my-burger-dfced.firebaseapp.com/"
                  >
                    <h2>BurgerKing Project</h2>
                    <h1 className="text-light">Demo Here</h1>
                  </a>
                  <p>React Project</p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
              <div className="gallery-items">
                <a
                  className="view img"
                  target="_blank"
                  href="images/portfolio/6.png"
                >
                  <img
                    src="images/portfolio/small/6.png"
                    alt="portfolio image"
                  />
                </a>

                <div className="gallery-text">
                  <h2>Fabric Fanes Project</h2>
                  <p>
                    Web App built on React-redux, Redux, React-router-dom and
                    Reactstrap
                  </p>
                </div>
              </div>
            </div>
            <div id="react-2nd-line ">
              <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                <div className="gallery-items">
                  <a
                    className="view img"
                    target="_blank"
                    href="images/portfolio/7.png"
                  >
                    <img
                      src="images/portfolio/small/7.png"
                      alt="portfolio image"
                    />
                  </a>

                  <div className="gallery-text">
                    <a
                      className=""
                      target="_blank"
                      href="https://letswrite-8f2de.firebaseapp.com/"
                    >
                      <h2>Scorpio Writes Project</h2>
                      <h1 className="text-light">Demo Here</h1>
                    </a>
                    <p>
                      Web App built on react, react-bootstrap, bootstrap,
                      React-router-dom and Reactstrap
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                <div className="gallery-items">
                  <a
                    className="view img"
                    target="_blank"
                    href="images/portfolio/8.png"
                  >
                    <img
                      src="images/portfolio/small/8.png"
                      alt="portfolio image"
                    />
                  </a>

                  <div className="gallery-text">
                    <a
                      className=""
                      target="_blank"
                      href="https://slimfit-c1180.firebaseapp.com/"
                    >
                      <h2>SlimFit Project</h2>
                      <h1 className="text-light">Demo Here</h1>
                    </a>
                    <p>
                      Web App built on react, react-bootstrap, bootstrap,
                      React-router-dom and Reactstrap
                    </p>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
          </div>

          <div
            id="portfolio"
            className="portfolio-area second-portfolio-section-padding"
          >
            <div className="container-fluid">
              <div className="row m-0 mt-0">
                <div className="col-md-12">
                  <div className="section-header">
                    <h2 id="wp-heading"></h2>
                  </div>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                  <div className="gallery-items">
                    <a
                      className="view img"
                      target="_blank"
                      href="https://khalqwelfare.pk/khalq/"
                    ></a>
                    <a className="view img" href="images/portfolio/1.png">
                      <img
                        src="images/portfolio/small/1.png"
                        alt="portfolio image"
                      />
                    </a>

                    <div className="gallery-text">
                      <a
                        className=""
                        target="_blank"
                        href="https://khalqwelfare.pk/khalq/"
                      >
                        <h2>KhalqWelfare Project</h2>
                      </a>
                      <p>WordPress Project</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                  <div className="gallery-items">
                    <a className="video-view img" href="">
                      <img
                        src="images/portfolio/small/2.png"
                        alt="portfolio image"
                      />
                    </a>

                    <div className="gallery-text">
                      <a
                        className=""
                        target="_blank"
                        href="https://naqshonigar.pk/"
                      >
                        <h2>NaqshoNigar Project</h2>
                      </a>
                      <p>WordPress Project</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                  <div className="gallery-items">
                    <a
                      className="view img"
                      target="_blank"
                      href="images/portfolio/3.png"
                    >
                      <img
                        src="images/portfolio/small/3.png"
                        alt="portfolio image"
                      />
                    </a>

                    <div className="gallery-text">
                      <a
                        className=""
                        target="_blank"
                        href="https://silkycool.pk/"
                      >
                        <h2>SilkyCool Project</h2>
                      </a>
                      <p>WordPress Project</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            id="portfolio"
            className="portfolio-area  third-portfolio-section-padding"
          >
            <div className="container-fluid">
              <div className="row m-0 mt-0">
                <div className="col-md-12">
                  <div className="section-header">
                    <h2></h2>
                  </div>
                </div>
              </div>

              <div className="row m-0">
                <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                  <div className="gallery-items">
                    <a
                      className="view img"
                      target="_blank"
                      href="images/portfolio/9.png"
                    >
                      <img
                        src="images/portfolio/small/9.png"
                        alt="portfolio image"
                      />
                    </a>

                    <div className="gallery-text">
                      <h2>Inventory Managment System</h2>
                      <p>
                        Project covering all kindaa stocking , selling, cutomer
                        order and all other things in Inventory
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                  <div className="gallery-items">
                    <a
                      className="view img"
                      target="_blank"
                      href="images/portfolio/10.png"
                    >
                      <img
                        src="images/portfolio/small/10.png"
                        alt="portfolio image"
                      />
                    </a>

                    <div className="gallery-text">
                      <h2>D Driving Project</h2>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-12 no-padding">
                  <div className="gallery-items">
                    <a
                      className="view img"
                      target="_blank"
                      href="images/portfolio/11.png"
                    >
                      <img
                        src="images/portfolio/small/11.png"
                        alt="portfolio image"
                      />
                    </a>

                    <div className="gallery-text">
                      <h2>The Blogers site Project</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section
            id="testimonial"
            className="testimonial-area section-padding"
          >
            <div className="container">
              <div className="row m-0">
                <div className="col-md-12">
                  <div className="section-header">
                    <h2>What Buyers Say</h2>
                  </div>
                </div>
              </div>
              <div className="row m-0">
                <div className="col-md-12">
                  <div className="carousel slide" id="testimonial-carousel">
                    <div className="carousel-inner">
                      <div className="item ">
                        <div className="client-img">
                          <img
                            src="images/testimonial/1.jpg"
                            alt="testimonial image"
                          />
                        </div>
                        <h5>
                          {" "}
                          - <strong>Ehtisham Han.</strong>
                        </h5>
                        <p>
                          My Experience working with Shoaib has been very
                          positive. I always receive quality service from him. I
                          highly recommend this guy to everyone because I think
                          he is one a of kind.
                        </p>
                      </div>

                      <div className="item active">
                        <div className="client-img">
                          <img
                            src="images/testimonial/2.jpg"
                            alt="testimonial image"
                          />
                        </div>
                        <h5>
                          {" "}
                          - <strong>Umar</strong>
                        </h5>
                        <p>
                          Shoaib has created fully working site from scratch for
                          me. He done every faunctionality accroding to my
                          requirmnents and also changes as per i said. I highly
                          recommend Shoaib to every one.
                        </p>
                      </div>

                      <div className="item">
                        <div className="client-img">
                          <img
                            src="images/testimonial/3.jpg"
                            alt="testimonial image"
                          />
                        </div>
                        <h5>
                          {" "}
                          - <strong>Abrar Sha.</strong>
                        </h5>
                        <p>
                          Shoaib is always creative, attentive to detail, and
                          consistent in meeting deadlines.
                        </p>
                      </div>
                    </div>

                    <ol className="carousel-indicators">
                      <li
                        data-target="#testimonial-carousel"
                        data-slide-to="0"
                      ></li>
                      <li
                        data-target="#testimonial-carousel"
                        data-slide-to="1"
                        className="active"
                      ></li>
                      <li data-target="#testimonial-carousel" data-slide-to="2">
                        {" "}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div id="contact" className="contact-area section-padding">
            <div className="">
              <div className="row m-0">
                <div className="col-md-12">
                  <div className="section-header text-center">
                    <h2>Contact Me</h2>
                  </div>
                </div>
              </div>
              <div className="invitation-area section-padding">
                <div className="container">
                  <div className="row m-0">
                    <div className="single-invite text-center">
                      <h2>do you have any project need to be done?</h2>

                      <p>
                        Here is the Email below. Specifie your requirments and
                        details about Project. We will catch you back soon to
                        develop an eye catching WEBSITE for you. Stay blessed.
                      </p>
                      <h4
                        style={{
                          color: "white",
                          textTransform: "lowercase",
                          marginTop: "10px",
                        }}
                      >
                        - shoaib4030891@gmail.com -
                      </h4>
                      <a href="#contact" className="my-btn-3">
                        Get started
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="footer-area"
            style={{ position: "absolute", marginBottom: "0px" }}
          >
            <div className="container">
              <div className="row m-0">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">
                  <p>&copy; All Right Reserved By Muhammad Shoaib</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
